import _ from 'lodash';
import { SupportedPlansType } from 'api/billing/types';
import { ObjectType } from 'api/pushes';
import {
  FieldDataType,
  FieldOption,
  FieldTypes,
} from 'components/organisms/module-settings/fields/types';
import { AutomationOperations } from 'components/organisms/tasks/filters/operations';

export enum AutomationTriggerIdentifier {
  ManualTrigger = 'MANUAL_TRIGGER',
  CronTrigger = 'CRON',
  AnyTaskDueDateIsAdded = 'ANY_TASK_DUE_DATE_IS_ADDED',
  AnyTaskDueDateIsRemoved = 'ANY_TASK_DUE_DATE_IS_REMOVED',
  AnyTaskDueDateIsPostponed = 'ANY_TASK_DUE_DATE_IS_POSTPONED',
  AnyTaskDueDateIsPreponed = 'ANY_TASK_DUE_DATE_IS_PREPONED',
  AnyTaskAssigneeIsAdded = 'ANY_TASK_ASSIGNEE_IS_ADDED',
  AnyTaskAssigneeIsRemoved = 'ANY_TASK_ASSIGNEE_IS_REMOVED',
  AnyTaskAssigneeIsCleared = 'ANY_TASK_ASSIGNEE_IS_CLEARED',
  AnyTaskDueDateOverdue = 'ANY_TASK_DUE_DATE_OVERDUE',
  NewMessageInTaskByUserType = 'NEW_MESSAGE_IN_TASK_BY_USER_TYPE',
  ResourceRequestCreated = 'RESOURCE_REQUEST_CREATED',
  ResourceRequestStatusUpdated = 'RESOURCE_REQUEST_STATUS_IS_UPDATED',
  BudgetCreated = 'BUDGET_CREATED',
  BudgetFieldUpdated = 'BUDGET_FIELD_UPDATED',
  BudgetDeleted = 'BUDGET_DELETED',
  PhaseProjectFinancialsBudgetsUpdated = 'PHASE_PROJECT_FINANCIALS_BUDGETS_UPDATED',
  TaskProjectFinancialsBudgetsUpdated = 'TASK_PROJECT_FINANCIALS_BUDGETS_UPDATED',
  /**
   * @deprecated
   */
  TaskCreated = 'TASK_CREATED',
  TaskCreatedV2 = 'TASK_CREATED_V2',
  TaskDeleted = 'TASK_DELETED',
  TaskSpotlighted = 'TASK_SPOTLIGHTED',
  TaskDueDateIsUpdated = 'TASK_DUE_DATE_IS_UPDATED',
  /**
   * @deprecated
   */
  TaskStatusIsUpdated = 'ANY_TASK_STATUS_IS_UPDATED',
  TaskStatusIsUpdatedV2 = 'TASK_STATUS_IS_UPDATED_V2',
  /**
   * @deprecated
   */
  TaskAnyFieldIsUpdated = 'ANY_TASK_FIELD_IS_UPDATED',
  TaskAnyFieldIsUpdatedV2 = 'TASK_ANY_FIELD_IS_UPDATED_V2',
  TaskApprovalStatusIsUpdated = 'TASK_APPROVAL_STATUS_IS_UPDATED',
  TaskApprovalRequest = 'TASK_APPROVAL_REQUEST',
  TaskCSATSubmitted = 'TASK_CSAT_SUBMITTED',
  TaskBecomesOverdue = 'TASK_BECOMES_OVERDUE',
  TaskRemainsInCertainStatus = 'TASK_REMIANS_IN_CERTAIN_STATUS',
  NewMessageInTask = 'NEW_MESSAGE_IN_TASK',
  TaskAssigneeIsUpdated = 'TASK_ASSIGNEE_IS_UPDATED',
  TaskDateReachingInXDays = 'TASK_DATE_REACHING_IN_X_DAYS',
  TaskDateCrossedXDays = 'TASK_DATE_CROSSED_X_DAYS',
  TaskDueDateReachingInXDays = 'TASK_DUE_DATE_REACHING_IN_X_DAYS',
  TaskDueDateCrossedXDays = 'TASK_DUE_DATE_CROSSED_X_DAYS',
  /**
   * @deprecated
   */
  PhaseCreated = 'PHASE_CREATED',
  PhaseCreatedV2 = 'PHASE_CREATED_V2',
  /**
   * @deprecated
   */
  PhaseStartDateIsChanged = 'ANY_PHASE_START_DATE_IS_CHANGED',
  PhaseStartDateIsChangedV2 = 'PHASE_START_DATE_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseDueDateIsChanged = 'ANY_PHASE_DUE_DATE_IS_CHANGED',
  PhaseDueDateIsChangedV2 = 'PHASE_DUE_DATE_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseStatusIsChanged = 'ANY_PHASE_STATUS_IS_CHANGED',
  PhaseStatusIsChangedV2 = 'PHASE_STATUS_IS_CHANGED_V2',
  /**
   * @deprecated
   */
  PhaseNameIsChanged = 'PHASE_NAME_IS_CHANGED',
  PhaseNameIsChangedV2 = 'PHASE_NAME_IS_CHANGED_V2',
  PhaseDeleted = 'PHASE_DELETED',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BiWeekly = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HalfYearly = 'HALF_YEARLY',
  ANNUALLY = 'ANNUALLY',
  DateFieldTrigger = 'DATE_FIELD_TRIGGER',
  FormDueDateIsUpdated = 'FORM_DUE_DATE_IS_UPDATED',
  FormStatusIsUpdated = 'FORM_STATUS_IS_UPDATED',
  FormAssigneeIsUpdated = 'FORM_ASSIGNEE_IS_UPDATED',
  FormAnyFieldIsUpdated = 'FORM_ANY_FIELD_IS_UPDATED',
  FormResponseSubmitted = 'FORM_RESPONSE_SUBMITTED',
  FormCreated = 'FORM_CREATED',
  NewMessageInForm = 'NEW_MESSAGE_IN_FORM',
  FormDeleted = 'FORM_DELETED',
  FormApprovalStatusIsUpdated = 'FORM_APPROVAL_STATUS_IS_UPDATED',
  FormApprovalRequest = 'FORM_APPROVAL_REQUEST',
  FormCSATSubmitted = 'FORM_CSAT_SUBMITTED',
  FormSpotlighted = 'FORM_SPOTLIGHTED',
  ProjectCreated = 'PROJECT_CREATED',
  ProjectAnyFieldIsUpdated = 'PROJECT_ANY_FIELD_IS_UPDATED',
  ProjectFinancialFieldIsUpdated = 'PROJECT_FINANCIAL_FIELD_IS_UPDATED',
  ProjectArchived = 'PROJECT_ARCHIVED',
  ProjectDeleted = 'PROJECT_DELETED',
  CustomerInvitedToProject = 'CUSTOMER_INVITED_TO_PROJECT',
  TeamMemberInvitedToProject = 'PROJECT_TEAM_MEMBER_IS_INVITED',
  ProjectPlaceholderResolved = 'PROJECT_PLACEHOLDER_RESOLVED',
  ProjectCustomerPortalChanged = 'PROJECT_CUSTOMER_PORTAL_CHANGED',
  CompanyAnyFieldIsUpdated = 'COMPANY_ANY_FIELD_IS_UPDATED',
  CompanyCreated = 'COMPANY_CREATED',
  CompanyDeleted = 'COMPANY_DELETED',
  InvoiceMovesFromDraftToInReview = 'INVOICE_MOVED_FROM_DRAFT_TO_IN_REVIEW',
  RowMatchesCondition = 'ROW_MATCHES_CONDITION',
  RowAdded = 'ROW_ADDED',
  RowUpdated = 'ROW_UPDATED',
  RowDeleted = 'ROW_DELETED',
  SheetTabCreated = 'SHEET_TAB_CREATED',
  SheetTabDeleted = 'SHEET_TAB_DELETED',
  SheetTabStatusUpdated = 'SHEET_TAB_STATUS_UPDATED',
  SheetTabAssigneeUpdated = 'SHEET_TAB_ASSIGNEE_UPDATED',
  SheetTabBecomesOverdue = 'SHEET_TAB_BECOMES_OVERDUE',
  SheetCreated = 'SHEET_CREATED',
  SheetDeleted = 'SHEET_DELETED',
  SheetAssigneeUpdated = 'SHEET_ASSIGNEE_UPDATED',
  SheetDueDateUpdated = 'SHEET_DUE_DATE_UPDATED',
  SheetStatusUpdated = 'SHEET_STATUS_UPDATED',
  SheetFieldUpdated = 'SHEET_FIELD_UPDATED',
  SheetApprovalResponseReceived = 'SHEET_APPROVAL_RESPONSE_RECEIVED',
  NewMessageInSheet = 'NEW_MESSAGE_IN_SHEET',
  SheetBecomesOverdue = 'SHEET_BECOMES_OVERDUE',
  SheetManualTrigger = 'SHEET_MANUAL_TRIGGER',
  ExpenseMovedFromDraftToSubmitted = 'EXPENSE_MOVED_FROM_DRAFT_TO_SUBMITTED',
  SignalOccurrenceCreated = 'SIGNAL_OCCURRENCE_CREATED',
}

export enum AutomationActionIdentifier {
  SendEmail = 'SEND_EMAIL',
  Sleep = 'SLEEP',
  StoreKeyEventValue = 'STORE_KEY_EVENT_VALUE',
  CreateTaskMessage = 'CREATE_TASK_MESSAGE',
  UpdateTaskStartDate = 'UPDATE_TASK_START_DATE',
  UpdateTaskDueDate = 'UPDATE_TASK_DUE_DATE',
  UpdateTaskField = 'UPDATE_TASK_FIELD',
  RequestTaskApproval = 'REQUEST_TASK_APPROVAL',
  NotifySomeone = 'NOTIFY_SOMEONE',
  InviteSomeone = 'INVITE_SOMEONE',
  SendForm = 'SEND_FORM',
  WebRequest = 'WEB_REQUEST',
  UpdateTaskStatus = 'UPDATE_TASK_STATUS',
  UpdateTaskPhase = 'UPDATE_TASK_PHASE',
  UpdateProjectFields = 'UPDATE_PROJECT_FIELDS',
  UpdateProjectFinancialFields = 'UPDATE_PROJECT_FINANCIAL_FIELDS',
  ShiftProjectDates = 'SHIFT_PROJECT_DATES',
  CreateTask = 'CREATE_TASK',
  CreateSubTask = 'CREATE_SUB_TASK',
  UpdateTaskAssignee = 'UPDATE_TASK_ASSIGNEE',
  ShiftTaskDates = 'SHIFT_TASK_DATES',
  DeleteTask = 'DELETE_TASK',
  CreateDocument = 'CREATE_DOCUMENT',
  SendProjectUpdates = 'SEND_PROJECT_UPDATES',
  ImportTemplate = 'IMPORT_TEMPLATE',
  CreateProjectMessage = 'CREATE_PROJECT_MESSAGE',
  UpdateResourceAllocation = 'UPDATE_RESOURCE_ALLOCATION',
  UpdateProjectStatus = 'UPDATE_PROJECT_STATUS',
  ArchiveProject = 'ARCHIVE_PROJECT',
  DeleteProject = 'DELETE_PROJECT',
  ChangeCustomerPortalForProject = 'CHANGE_CUSTOMER_PORTAL_FOR_PROJECT',
  UpdatePhaseStartDate = 'UPDATE_PHASE_START_DATE',
  UpdatePhaseDueDate = 'UPDATE_PHASE_DUE_DATE',
  UpdatePhaseStatus = 'UPDATE_PHASE_STATUS',
  DeletePhase = 'DELETE_PHASE',
  NotifyViaSlack = 'NOTIFY_VIA_SLACK',
  InviteTeamMember = 'INVITE_TEAM_MEMBER',
  SendWebRequest = 'SEND_WEB_REQUEST',
  PushTaskWebHook = 'PUSH_TASK_WEBHOOK',
  PushProjectWebHook = 'PUSH_PROJECT_WEBHOOK',
  PushPhaseWebHook = 'PUSH_PHASE_WEBHOOK',
  PushSignalWebHook = 'PUSH_SIGNAL_WEBHOOK',
  ExitAutomation = 'EXIT_AUTOMATION',
  FollowTask = 'FOLLOW_TASK',
  UpdatePhaseName = 'UPDATE_PHASE_NAME',
  AssignResourceRequestApprover = 'ASSIGN_RESOURCE_REQUEST_APPROVER',
  AssignApprovalToInvoice = 'ASSIGN_APPROVAL_TO_INVOICE',
  SpotlightTask = 'SPOTLIGHT_TASK',
  DeleteAllocations = 'DELETE_ALLOCATIONS',
  ShiftAllocations = 'SHIFT_ALLOCATIONS',
  UpdateCompanyFields = 'UPDATE_COMPANY_FIELDS',
  CreateSheetTab = 'CREATE_SHEET_TAB',
  UpdateSheetTabAssignee = 'UPDATE_SHEET_TAB_ASSIGNEE',
  UpdateSheetAssignee = 'UPDATE_SHEET_ASSIGNEE',
  UpdateSheetStartDate = 'UPDATE_SHEET_START_DATE',
  UpdateSheetDueDate = 'UPDATE_SHEET_DUE_DATE',
  ShiftSheetDates = 'SHIFT_SHEET_DATES',
  ChangeSheetTabStatus = 'CHANGE_SHEET_TAB_STATUS',
  FreezeSheetTab = 'FREEZE_SHEET_TAB',
  UpdateSheetField = 'UPDATE_SHEET_FIELD',
  RequestSheetTabApproval = 'REQUEST_SHEET_TAB_APPROVAL',
  RequestSheetApproval = 'REQUEST_SHEET_APPROVAL',
  DeleteRow = 'DELETE_ROW',
  DeleteSheet = 'DELETE_SHEET',
  DeleteSheetTab = 'DELETE_SHEET_TAB',
  UpdateSheetStatus = 'UPDATE_SHEET_STATUS',
  UpdateSheetTabDueDate = 'UPDATE_SHEET_TAB_DUE_DATE',
  AddRow = 'ADD_ROW',
  UpdateRow = 'UPDATE_ROW',
  CreateSheetMessage = 'CREATE_SHEET_MESSAGE',
  FreezeSheet = 'FREEZE_SHEET',
  FollowSheet = 'FOLLOW_SHEET',
  AutoApproveExpense = 'AUTO_APPROVE_EXPENSE',
  AssignApprovalToExpense = 'ASSIGN_APPROVAL_TO_EXPENSE',
  CreateBudget = 'CREATE_BUDGET',
  UpdateBudgetField = 'UPDATE_BUDGET_FIELD',
}

export enum AutomationSource {
  ProjectTemplate = 'PROJECT_TEMPLATE',
  ProjectPhaseTemplate = 'PROJECT_PHASE_TEMPLATE',
  TaskTemplate = 'TASK_TEMPLATE',
  None = 'NONE',
  GLOBAL = 'GLOBAL',
  FormTemplate = 'FORM_TEMPLATE',
  GlobalProject = 'GLOBAL_PROJECT',
  GlobalProjectPhase = 'GLOBAL_PROJECT_PHASE',
  GlobalTask = 'GLOBAL_TASK',
  GlobalForm = 'GLOBAL_FORM',
  GlobalResourceRequest = 'GLOBAL_RESOURCE_REQUEST',
  GlobalProjectFinancialsBudget = 'GLOBAL_PROJECT_FINANCIALS_BUDGET',
  GlobalCompany = 'GLOBAL_COMPANY',
  GlobalInvoice = 'GLOBAL_INVOICE',
  GlobalCreditNote = 'GLOBAL_CREDIT_NOTE',
  SheetTemplate = 'SHEET_TEMPLATE',
  ExpenseApproval = 'EXPENSE_APPROVAL',
  GlobalSignal = 'GLOBAL_SIGNAL',
}

export const GLOBAL_AUTOMATIONS = [
  AutomationSource.GlobalProject,
  AutomationSource.GlobalTask,
  AutomationSource.GlobalProjectPhase,
  AutomationSource.GlobalForm,
  AutomationSource.GlobalResourceRequest,
  AutomationSource.GlobalSignal,
  AutomationSource.GlobalProjectFinancialsBudget,
  AutomationSource.None,
];

export enum AutomationInputFieldType {
  TASK = 'TASK',
  PROJECT = 'PROJECT',
  ProjectPhase = 'PROJECT_PHASE',
  TaskFieldsSelector = 'TASK_FIELDS_SELECTOR',
  ProjectFieldsSelector = 'PROJECT_FIELDS_SELECTOR',
  ProjectFinancialsBudgetFieldsSelector = 'PROJECT_FINANCIALS_BUDGET_FIELDS_SELECTOR',
  ResourceRequest = 'RESOURCE_REQUEST',
  ProjectFinancialsBudget = 'PROJECT_FINANCIALS_BUDGET',
}

export enum AutomationFieldRenderType {
  Cron = 'CRON',
  SingleSelect = 'SINGLE_SELECT',
  MultiSelect = 'MULTI_SELECT',
  SimpleSearchFilter = 'SIMPLE_SEARCH_FILTER',
  RichText = 'RICH_TEXT',
  MultiSelectPopup = 'MULTI_SELECT_POPUP',
  LabelBold = 'LABEL_BOLD',
  Default = '_DEFAULT_',
  KeyValuePair = 'KEY_VALUE_PAIR',
  Toggle = 'TOGGLE',
  Radio = 'RADIO',
  Email = 'EMAIL',
  EmailInput = 'EMAIL_INPUT',
  Squad = 'SQUAD',
  AllProjectMembers = 'ALL_PROJECT_MEMBERS',
  Iso8601PeriodField = 'ISO_8601_PERIOD_FIELD',
  FormQuestion = 'FORM_QUESTION',
  DaysSelectorInput = 'DAYS_SELECTOR_INPUT',
  MessageSenderType = 'MESSAGE_SENDER_TYPE',
  NoWebhooksFound = 'NO_WEBHOOKS_FOUND',
  /**
   * @deprecated
   */
  ComposeEmail = 'COMPOSE_EMAIL',
  TemplatePicker = 'TEMPLATE_PICKER',
  ObjectSelector = 'OBJECT_SELECTOR',
  MultipleObjectsSelector = 'OBJECTS_SELECTOR',
  EmailCompose = 'EMAIL_COMPOSE',
  Effort = 'EFFORT_FIELD',
  TimesheetHoursField = 'TIMESHEET_HOURS_FIELD',
  ConnectToSlack = 'CONNECT_TO_SLACK',
  JsonEditor = 'JSON_EDITOR',
  ScheduleRepeatPicker = 'SCHEDULE_REPEAT_PICKER',
  ScheduleStartPicker = 'SCHEDULE_START_PICKER',
}

export type AutomationTriggerFieldOption = FieldOption & {
  label: string;
  active: boolean;
  valueStr?: string;
};

export enum FilterContext {
  Automations,
  Others,
}

export type AutomationField = {
  sourceType: ObjectType;
  fieldId: number;
  fieldName: string;
  fieldNameSanitized?: string;
  fieldType: FieldTypes;
  fieldDataType: FieldDataType;
  customField: boolean;
  parentFieldName: string;
  objectType: ObjectType;
  fieldGroup: string;
  fieldColumnName: string;
  fieldLabel: string;
  private: false;
  isEditable: boolean;
  required?: boolean;
  automationInputFieldType?: AutomationInputFieldType;
  sticky?: boolean;
  dynamic?: boolean;
  triggersDynamic?: boolean;
  placeholderValue: string;
  placeholderLabel: string;
  renderAs?: AutomationFieldRenderType;
  renderParams?: AutomationFieldRenderParams[];
  hint?: string;
  metaData?: {
    optionsAvailable?: boolean;
    options: AutomationTriggerFieldOption[];
    range?: {
      min: number;
      max: number;
    };
    rangeAvailable?: boolean;
    /**
     * This is just a FE property
     */
    allowRelativeDateOps?: boolean;
    /**
     * This is just a FE property
     */
    allowAbsDateOps?: boolean;
    /**
     * This is just a FE property
     */
    filterContext?: FilterContext;
  };
  allowedTriggerConditionOperations?: AutomationOperations[];
  // Preserved original fieldLabel value before translation (added by translate-keys-transformer)
  fieldLabelOriginal?: string;
};

export type AutomationFieldOption = Omit<FieldOption, 'value'> & {
  automationValueMeta?: string | number | Record<string, unknown>;
  value?: number | string;
  active?: boolean;
  valueStr?: string;
  automationFeatureGating?: {
    planType: SupportedPlansType;
    featureGated: boolean;
  };
  // Preserved original label value before translation (added by translate-keys-transformer)
  labelOriginal?: string;
};

export type AutomationActionInputField = Omit<AutomationField, 'metaData'> & {
  required?: boolean;
  hidden?: boolean;
  hint?: string;
  hintColor?: string;
  fieldValue?: unknown;
  isValueMeta?: boolean;
  fieldSectionLabel?: string;
  inputJsonPath?: string;
  metaFieldValue?: unknown;
  childFields?: AutomationActionInputField[];
  metaData: Omit<AutomationField['metaData'], 'options'> & {
    options?: AutomationFieldOption[];
  };
  renderParams?: AutomationFieldRenderParams[];
  dynamicFriendlyVariableFields?: boolean;
  // adding this as based some parent field value, BE might send some updated field value for child fields, But these updated values are not rendered in the UI.
  overrideActionInputFieldValue?: boolean;
  // Preserved original fieldLabel value before translation (added by translate-keys-transformer) for data-cy attributes
  fieldLabelOriginal?: string;
};

export const isValueMetaStringOrNumber = (
  m: string | number | Record<string, unknown> | undefined,
): m is string | number => _.isString(m) || _.isNumber(m);

export enum AutomationFieldRenderParams {
  ShowUsers = 'SHOW_USERS',
  ShowTeams = 'SHOW_TEAMS',
  ShowProjectOwner = 'SHOW_PROJECT_OWNER',
  ShowAllProjectMembers = 'SHOW_ALL_PROJECT_MEMBERS',
  ShowCustomerProjectMembers = 'SHOW_CUSTOMER_PROJECT_MEMBERS',
  ShowInternalProjectMembers = 'SHOW_INTERNAL_PROJECT_MEMBERS',
  ShowTimesheetApprovers = 'SHOW_TIMESHEET_APPROVERS',
  ShowInvitedUserEmail = 'SHOW_INVITED_USER_EMAIL',
  HorizontalRadio = 'HORIZONTAL_RADIO',
  VerticalRadio = 'VERTICAL_RADIO',
  Bold = 'BOLD',
  SimpleVariable = 'SIMPLE_VARIABLE',
  ConditionalVariable = 'CONDITIONAL_VARIABLE',
  Emojis = 'EMOJIS',
  Checkbox = 'CHECKBOX',
  Images = 'IMAGES',
  ShowDays = 'SHOW_DAYS',
  ShowWeeks = 'SHOW_WEEKS',
  ShowMonths = 'SHOW_MONTHS',
  LimitText = 'LIMIT_TEXT',
  AllowSmartFills = 'ALLOW_SMART_FILLS',
  ShowCustomUsers = 'SHOW_CUSTOM_USERS',
  ShowCompanyTeams = 'SHOW_COMPANY_TEAMS',
}
